// MUI
import { Box, Typography, Button } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

// Third party
import { useNavigate } from 'react-router-dom';

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#0E1720',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background:
            `radial-gradient(800px 500px at 20% 10%, rgba(0,224,255,0.08), transparent 60%),
             radial-gradient(700px 500px at 90% 90%, rgba(29,176,191,0.10), transparent 60%)`,
          pointerEvents: 'none',
        },
      }}
    >
      <Box
        sx={{
          width: 'min(480px, 92vw)',
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          alignItems: 'center',
          color: '#fff',
          textAlign: 'center',
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 70, color: '#f64f4f' }} />

        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Unauthorized Access
        </Typography>

        <Typography sx={{ color: '#A6B1C2' }}>
          You do not have permission to view this page.
        </Typography>

        <Button
          onClick={() => navigate('/login')}
          variant="outlined"
          sx={{
            color: '#00E0FF',
            borderColor: '#00E0FF',
            px: 3.5,
            py: 1.2,
            fontWeight: 'bold',
            textTransform: 'none',
            borderRadius: '5px',
            '&:hover': {
              borderColor: '#1D6F78',
            },
          }}
        >
          Go to Login
        </Button>
      </Box>
    </Box>
  );
};

export default UnauthorizedPage;
